import React, { useRef, useState } from "react";
import { Button, Checkbox } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import TopTitleFormComponent from "./TopTitleFormComponent";
import "./AdmissionDocumentRedesign.css";
import { StandardDrawerFooter } from "./StandardDrawer";
import FormContentSkeleton from "./FormContentSkeleton";
import { getDoc, doc } from "firebase/firestore";
import { useEffect } from "react";
import { db } from "../../firebase";
import ReactToPrint from "react-to-print";

function ViewConfidentialityPolicy(props) {
  //Tous les states des données récupérées par client

  const [signaturePic, setSignaturePic] = useState(null);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");

  const printRef = useRef(); // Ajouter cette ligne

  function formatDate(timestamp) {
    const date = timestamp.toDate();
    const day = date.getDate().toString().padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const timeZone = date
      .toLocaleString("en", { timeZoneName: "short" })
      .split(" ")
      .pop();

    return `${day} ${month} ${year} ${hours}:${minutes} ${timeZone}`;
  }

  const fetchSignatureUrl = async () => {
    const docRef = doc(db, "ConfidentialityPolicy", props.clientId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      const signatureUrl = data.signatureURL;
      setSignaturePic(signatureUrl);
      setText1(data.text1);
      setText2(data.text2);
      setText3(data.text3);
    } else {
      console.log("No such document (signaturePic ref)!");
    }
  };

  useEffect(() => {
    fetchSignatureUrl().finally(() => setIsDataLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <style>
        {`
          @media print {
            #printableContent {
              height: auto !important;
              overflow-y: visible !important;
            }
          }
        `}
      </style>
      <div
        className="admission-document-shell admission-card-form-shell psychiatric-costs-view"
        // className="inputAndLabelModalContainerTitle2"
        style={{ width: "auto", height: "100%" }}
      >
        <TopTitleFormComponent
          title="Confidentiality Policy Form"
          eyebrow="ADMISSION FORM"
          subtitle={`${props.firstName || "Client"} ${props.lastName || ""}`.trim()}
          closemodal={props.closemodal}
        />

        <div
          id="printableContent"
          className={`admission-document-body ${
            isDataLoading ? "form-content-loading" : ""
          }`}
          ref={printRef}
        >
          <FormContentSkeleton rows={3} />
          <div className="client-name-container">
            Confidentiality policy form for: {props.firstName} {props.lastName}
          </div>
          <br />
          <div className="text-block">{text1}</div>
          <div className="checkbox-container-margin">
            <Checkbox checked={true} />I fully understand and agree to the above
            terms.
          </div>

          <div className="text-block">{text2}</div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />I fully understand and agree to the above
            terms.
          </div>

          <div className="text-block">{text3}</div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />I fully understand and agree to the above
            terms.
          </div>

          <div className="signature-date-container">
            <div className="text-block-2">
              Timestamp signature :{" "}
              {formatDate(props.ConfidentialityPolicyDateSigned)}{" "}
            </div>
            <div className="signature-title">
              Client signature (
              <span style={{ fontWeight: "bold" }}>
                {props.firstName} {props.lastName}
              </span>
              ):
            </div>
            <img
              alt="Signature"
              className="signature-pic-roi"
              src={signaturePic}
            />
          </div>
        </div>
        <StandardDrawerFooter className="admission-document-footer">
          <>
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={props.closemodal}
            >
              Cancel
            </Button>

            <ReactToPrint
              trigger={() => (
                <Button variant="contained" style={{ marginLeft: "20px" }}>
                  Print
                </Button>
              )}
              content={() => printRef.current}
              onAfterPrint={props.closemodal}
            />
          </>
        </StandardDrawerFooter>
      </div>
    </>
  );
}

export default ViewConfidentialityPolicy;
